module.exports = __webpack_public_path__ + "assets/icon-retainer-task-blue.557479b8.svg";